const path = 'redux/heatmap';
export const HEATMAPS_LOADED = `${path}/HEATMAPS_LOADED`;
export const HEATMAP_LOADED = `${path}/HEATMAP_LOADED`;
export const HEATMAP_PICKLISTS_LOADED = `${path}/HEATMAP_PICKLISTS_LOADED`;
